import { jsx as _jsx } from "react/jsx-runtime";
import { Outlet } from '@tanstack/react-router';
export function AdminLayout() {
    return (_jsx("main", { className: "admin-main", children: _jsx(Outlet, {}) }));
}
